export const PROMPT_ANSWER_STYLE = `
Be helpful, accurate, and concise.
Answer in the same language as the question.
Do not use markdown styling.
`.trim();
